import { useMemo } from 'react';
import { isLightColor } from '@carbonify/ui';

interface HeroTheme {
  theme?: 'auto' | 'light' | 'dark';
  image?: { bgColor: string } | { responsiveImage: { bgColor: string } };
  imageDesktop?: { bgColor: string } | { responsiveImage: { bgColor: string } };
  variant?: 'text_left' | 'text_center' | 'blog_landing' | 'blog_post' | '2_col' | '2_row';
}

export default function useHeroTheme({ theme = 'auto', imageDesktop, image = imageDesktop, variant }: HeroTheme = {}):
  'light' | 'dark' {
  return useMemo(() => {
    if (theme && theme !== 'auto') return theme;

    if (variant && variant.startsWith('grid_')) return 'dark';

    if (
      image &&
      ('responsiveImage' in image ? !isLightColor(image.responsiveImage.bgColor) : !isLightColor(image.bgColor))
    )
      return 'light';

    return 'dark';
  }, [theme, variant, image]);
}
